import { Header, Table } from 'components'

/**
 * The parts of the Social page that exist BEFORE its chunk loads: the header copy and a skeleton.
 * Kept out of `GtmSocialPage.tsx` for the same reason as the Trade shows shell: the page imports
 * the generated strategy snapshot and is `React.lazy` in App.tsx, so this module (the Suspense
 * fallback, imported eagerly) must not import it.
 */
export const SOCIAL_TITLE = 'Social'

export const SOCIAL_DESCRIPTION =
  'LinkedIn first for inbound demos, Instagram as proof. Sourced facts become drafts and a person approves a weekly batch. Nothing posts unapproved; approved items may go out through an official API once a connector is on.'

export const SocialSkeleton = () => (
  <>
    <Header title={SOCIAL_TITLE} description={SOCIAL_DESCRIPTION} />
    {/* `type: 'string'`: the Table's filter panel logs an error for any column without one. */}
    <Table
      fillBottom
      loading
      rows={[]}
      columns={['Channel', 'Format', 'Account', 'Per week', 'Pillar'].map((headerName) => ({
        field: headerName,
        headerName,
        width: 200,
        type: 'string',
        sortable: false,
      }))}
      hideExport
    />
  </>
)
